/**
 * El nombre con el que se guarda un documento al descargarlo.
 *
 * «Acta de nacimiento» + «José Pérez Ñáñez» → `Acta-de-nacimiento-Jose-Perez-Nanez.pdf`.
 *
 * **Es el mismo nombre que el archivo tiene en Storage**, y eso no es casualidad:
 * lo escribe igual `scripts/import-documentos-expediente.ts` al subir la carga de
 * RR.HH. Si los dos derivaran, quien descargue tendría un archivo que no se parece
 * al que el portal enseña.
 *
 * Sin acentos y sin nada que no sea letra, número, punto o guion: un nombre de
 * descarga viaja a un sistema de archivos que puede ser cualquiera, y una diagonal
 * o dos puntos lo rompen en Windows.
 */
export const nombreDescarga = (...partes: readonly string[]): string => {
  const limpio = partes
    .join(' ')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-zA-Z0-9._-]+/g, '-')
    .replace(/^[.-]+|-+$/g, '')
    .slice(0, 76);

  return `${limpio.length > 0 ? limpio : 'documento'}.pdf`;
};
